import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/SignInIntro/signInIntroCopy";

/**
 * UI1 Intro copy — strings wrapped in ~...~ for i18n-google scan.
 * Until scan runs, UI displays markers literally; scan strips ~ and wires I18n.t.
 */
export function createSignInIntroCopy(locale?: string) {
  const I18n = I18nUtil.createScoped(Translations, locale);
  return {
    ctaGetStarted: I18n.t("Get Started"),
    intro1: {
      headlinePrefix: I18n.t("Finally, a"),
      headlineAccent: I18n.t("money person"),
      headlineSuffix: I18n.t("on your side."),
      subtitle: I18n.t("Across cash, investing, goals, and the years ahead."),
      bubble: I18n.t(
        "Hi — I'm Ed. From here on I keep an eye on your money, so you don't have to.",
      ),
    },
    intro2: {
      headlinePrefix: I18n.t("I watch your"),
      headlineAccent: I18n.t("whole money life"),
      headlineSuffix: I18n.t("."),
      subtitle: I18n.t("Nothing slips."),
      tags: {
        cash: I18n.t("Cash"),
        investing: I18n.t("Investing"),
        decisions: I18n.t("Decisions"),
        wealth: I18n.t("Wealth"),
      },
    },
    intro3: {
      headline: I18n.t("I keep your goals moving forward."),
      subtitle: I18n.t("Set the goal. I'll build the plan."),
      goals: {
        safetyNet: I18n.t("Safety net"),
        downPayment: I18n.t("Down payment"),
        retirement: I18n.t("Retirement"),
      },
    },
    intro4: {
      headline: I18n.t("Come back to clarity, not catch-up."),
      subtitle: I18n.t("I keep working while you're away."),
      statNumber: "3",
      statLine1: I18n.t("things I handled"),
      statLine2: I18n.t("since you last opened"),
      bullets: [
        I18n.t("Moved you 4% closer to your goal"),
        I18n.t("Caught a better savings rate"),
        I18n.t("Filtered out 12 distractions"),
      ],
    },
  } as const;
}

export type SignInIntroCopy = ReturnType<typeof createSignInIntroCopy>;

/**
 * Backward-compatible default export for legacy callsites/tests.
 * Runtime-sensitive views should call createSignInIntroCopy(locale).
 */
export const SIGN_IN_INTRO_COPY = createSignInIntroCopy();
